<oo-loading-container [status]="state.status">
  <ng-template>
    @if (state.teams.length) {
      <mat-accordion>
        @for (team of state.teams; track team.id) {
          <mat-expansion-panel (opened)="teamOpened(team.id)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="oo-team-line">
                  <img [ngSrc]="team.imageUrl ?? ('https://ui-avatars.com/api/?size=30&name=' + team.name)"
                       class="oo-tour-image oo-dense"
                       height="30"
                       width="30">
                  <span>{{ team.name }}</span>
                </div>
              </mat-panel-title>
              @if (!team.isActive) {
                <mat-panel-description>Deactivated</mat-panel-description>
              }
            </mat-expansion-panel-header>

            @if (team.id === state.currentSelectedTeamId || team.id === state.prevSelectedTeamId) {
              <oo-team-players-list
                (activateTeam)="toggleIsActive($event, true)"
                (deactivateTeam)="toggleIsActive($event, false)"
                [isManageable]="state.isManageable"
                [team]="team">
              </oo-team-players-list>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    }

    @if (!state.teams.length) {
      <mat-card appearance="outlined">
        <mat-card-content>
          <div>
            No teams yet{{ state.isManageable ? ', please create one' : '' }}
          </div>
        </mat-card-content>
      </mat-card>
    }
  </ng-template>
</oo-loading-container>
